import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CompaniesListComponent} from './companies-list.component';
import {TranslateDirective, TranslatePipe} from '@ngx-translate/core';
import {IonicModule} from '@ionic/angular';

@NgModule({
  declarations: [CompaniesListComponent],
  imports: [
    CommonModule,
    TranslatePipe,
    TranslateDirective,
    IonicModule
  ],
  exports: [
    CompaniesListComponent
  ]
})
export class CompaniesListModule {
}
